// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2IcFR","dragIcon":"Choice_dragIcon__-h6nt","left":"Choice_left__3Hbr4","input":"Choice_input__2rL4I"};